import {createSlice} from '@reduxjs/toolkit'
import socketFactory from '../../../../utils/socketFactory.js';

import{

}from './AddEventThunks'

const initialState = {
    title:"",
    invites: [],
    showUserList: false,
    description: "",
    filteredUsers: [],
    isDropdownHovered: false,
    showRoomDropdown: false,
    rooms:[],
    nonGuestUsers:[],
    open:false,
    showMonthList:false,
    showYearList:false,
    showDescription:false,
    isEditingTime:false,
    selectedRoomUpdate:null,
    time:"",
    duration:"30",
    reminder:"10",
    inviteInput:"",
    confirmDialogOpen:false
}

const AddEventSlice = createSlice({
    name:'addEvent',
    initialState,
    reducers:{
        setInit:(state)=>{
            state.title = initialState.title;
            state.invites = initialState.invites;
            state.showUserList = initialState.showUserList;
            state.description = initialState.description;
            state.filteredUsers = initialState.filteredUsers;
            state.isDropdownHovered = initialState.isDropdownHovered;
            state.showRoomDropdown = initialState.showRoomDropdown;
            state.rooms = initialState.rooms;
            state.nonGuestUsers = initialState.nonGuestUsers;
            state.open = initialState.open;
            state.showMonthList = initialState.showMonthList;
            state.showYearList = initialState.showYearList;
            state.showDescription = initialState.showDescription;
            state.isEditingTime = initialState.isEditingTime;
            state.time = initialState.time;
            state.duration = initialState.duration;
            state.reminder = initialState.reminder;
            state.inviteInput = initialState.inviteInput;
            state.confirmDialogOpen = initialState.confirmDialogOpen
        },
        setTitle: (state, action) => {
            state.title = action.payload;
        },
        setShowUserList: (state, action) => {
            state.showUserList = action.payload;
        },
        setDescription: (state, action) => {
            state.description = action.payload;
        },
        setFilteredUsers: (state, action) => {
            state.filteredUsers = action.payload;
        },
        setIsDropdownHovered: (state, action) => {
            state.isDropdownHovered = action.payload;
        },
        setShowRoomDropdown: (state, action) => {
            state.showRoomDropdown = action.payload;
        },
        setInvites: (state, action) => {
            state.invites = action.payload;
        },
        setNonGuestUsers: (state, action) => {
            state.nonGuestUsers = action.payload;
        },
        setRooms: (state, action) => {
            state.rooms = action.payload;
        },
        setOpen:(state,action)=>{
            state.open = action.payload
        },
        setShowMonthList:(state,action)=>{
            state.showMonthList = action.payload
        },
        setShowYearList:(state,action)=>{
            state.showYearList = action.payload
        },
        setShowDescription:(state,action)=>{
            state.showDescription = action.payload
        },
        setIsEditingTime:(state,action)=>{
            state.isEditingTime = action.payload
        }   ,
        setSelectedRoomupdate:(state,action)=>{
            state.selectedRoomUpdate = action.payload;
        },
        setConfirmDialogOpen:(state,action)=>{
            state.confirmDialogOpen = action.payload
        },
        setTime:(state,action)=>{
            state.time = action.payload
        }  ,
        setDuration:(state,action)=>{
            state.duration = action.payload
        },
        setReminder:(state,action)=>{
            state.reminder = action.payload
        },
        setInviteInput:(state,action)=>{
            state.inviteInput = action.payload
        },

        
    }
})
export const{
    setInit,
    setTitle,
    setShowUserList,
    setDescription,
    setFilteredUsers,
    setIsDropdownHovered,
    setShowRoomDropdown,
    setInvites,
    setRooms,
    setNonGuestUsers,
    setOpen,
    setShowMonthList,
    setShowYearList,
    setShowDescription,
    setIsEditingTime,
    setSelectedRoomupdate,
    setConfirmDialogOpen,
    setTime,
    setDuration,
    setReminder,
    setInviteInput
} = AddEventSlice.actions

export const NEW_RESERVATION = socketFactory.emit('newReservation', 'socket/newReservation');
export const UPDATE_RESERVATION = socketFactory.emit('updateReservation', 'socket/updateReservation');
export const DELETE_RESERVATION = socketFactory.emit('deleteReservation', 'socket/deleteReservation');

export default AddEventSlice.reducer